import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from "@/components/auth/Login";
import Password from "@/components/auth/Password";
import Otp from "@/components/auth/Otp";
import forget from "@/components/auth/Forget";
import NewPassword from "@/components/auth/NewPassword";
import CheckLogin from "@/components/auth/CheckLogin";
import NotFound from '../views/NotFound.vue'
/*import Cookies from 'js-cookie';*/


const routes = [
    {
        path: '/',
        name: 'HomeView',
        component: HomeView,
        meta: {
            requiresAuth: true,
        title:'ffff'},
    },

    {
        path: '/admin',
        meta: {requiresAuth: true},
        children: [
            {
                path: 'users/users',
                name: 'UsersComponent',
                meta: {requiresAuth: true,title:'لیست کاربران'},

                component: () => import('../components/admin/Users')
            },
            {
                path: 'users/users-portal',
                name: 'UsersPortal',
                meta: {requiresAuth: true ,
                    title:'کاربران پرتال',
                    requiredFeatures: ['portal']},

                component: () => import('../components/admin/UsersPortal')
            },
            {
                path: 'users/users-role',
                name: 'UsersRole',
                meta: {requiresAuth: true,title:'نقش کاربران',},

                component: () => import('../components/admin/UsersRole')
            },
            {
                path: 'users/bans',
                name: 'Bans',
                meta: {requiresAuth: true,title:'مسدودیت ها'},

                component: () => import('../components/admin/BansView')
            },
            {
                path: 'setting',
                name: 'SettingComponent',
                meta: {requiresAuth: true,title:'تنظیمات'},

                component: () => import('../components/admin/Setting')
            },
            {
                path: 'api',
                name: 'ApisComponent',
                meta: {requiresAuth: true,
                    requiredFeatures: ['artificial_intelligence'],
                    title:'api ها'},

                component: () => import('../components/admin/Apis')
            },
            {
                path: 'api-connections',
                name: 'ApiConnections',
                meta: {requiresAuth: true,
                    requiredFeatures: ['artificial_intelligence'],
                    title:'اتصال api ها'},

                component: () => import('../components/admin/ApiConnections')
            },
            {
                path: 'log-system',
                name: 'LogsSystem',
                meta: {requiresAuth: true,title:'لاگ های سیستم'},
                component: () => import('../components/admin/SystemLogs')
            },

            {
                path: 'financial',
                name: 'FinancialComponent',
                meta: {requiresAuth: true,title:' فهرست پرداخت ها '},

                component: () => import('../components/admin/Financial')
            },
            {
                path: 'work-flow',
                name: 'WorkFlow',
                meta: {requiresAuth: true,
                    requiredFeatures: ['workflow_management'],title:'گردش کارها'},

                component: () => import('../components/admin/workflow/WorkFlow.vue')
            },
            {
                path: 'work-flow/diagram/:id?',
                name: 'DiagramComponent',
                meta: {requiresAuth: true,},

                component: () => import('../components/admin/workflow/Diagram.vue')
            },
            {
                path: 'licences',
                name: 'Licences',
                meta: {requiresAuth: true,title:'لایسنس ها'},

                component: () => import( '../components/admin/Licences')
            },
            {
                path: 'bills/:id?',
                name: 'BillsComponent',
                meta: {requiresAuth: true,title:'پرداخت ها'},

                component: () => import( '../components/admin/Bills')
            },
            {
                path: 'call-center',
                name: 'CallCenter',
                meta: {requiresAuth: true,title:'مرکز تماس'},

                component: () => import( '../components/admin/CallCenter')
            },
            {
                path: 'queues',
                name: 'Queues',
                meta: {requiresAuth: true,title:'مدیریت صف ها'},

                component: () => import( '../components/admin/Queues')
            },
            {
                path: 'zones',
                name: 'zonesManagement',
                meta: {requiresAuth: true,title:'مدیریت مناطق'},

                component: () => import( '../components/admin/zonesManagement/ZonesManagement')
            },
            {
                path: 'logs/telegram',
                meta: {requiresAuth: true,title:'لاگ های تلگرام'},
                name: 'TelegramLogs',
                component: () => import('../components/management/logs/TelegramLogs')
            },
            {
                path: 'logs/whatsapp',
                meta: {requiresAuth: true,title:'لاگ های واتس آپ'},
                name: 'WhatsappLogs',
                component: () => import('../components/management/logs/WhatsappLogs')
            },
            {
                path: 'logs/instagram',
                meta: {requiresAuth: true,title:'لاگ های اینستاگرام'},
                name: 'InstagramLogs',
                component: () => import('../components/management/logs/InstagramLogs')
            },
            {
                path: 'logs/bale',
                meta: {requiresAuth: true,title:'لاگ های بله'},
                name: 'BaleLogs',
                component: () => import('../components/management/logs/BaleLogs')
            },


        ]
    },

    {
        path: '/management',
        meta: {requiresAuth: true},
        children: [
            {
                path: 'dashboard',
                meta: {requiresAuth: true},
                name: 'DashboardManagement',
                component: () => import('../components/management/Dashboard'),

            },
            {
                path: 'profile-setting',
                name: 'ProfileSetting',
                meta: {requiresAuth: true},

                component: () => import('../components/admin/ProfileSetting')
            },
            {
                path: 'request-status',
                name: 'RequestStatus',
                meta: {requiresAuth: true},

                component: () => import( '../components/management/RequestStatus')
            },
            {
                path: 'request-types',
                name: 'RequestType',
                meta: {requiresAuth: true},

                component: () => import( '../components/admin/RequestTypes')
            },
            {
                path: 'tags',
                name: 'TagsComponent',
                meta: {requiresAuth: true},

                component: () => import( '../components/admin/Tags')
            },
            {
                path: 'faq',
                name: 'FaqComponent',
                meta: {requiresAuth: true},
                component: () => import( '../components/admin/Faq')
            },
            {
                path: 'faq-category',
                name: 'FaqCatComponent',
                meta: {requiresAuth: true},
                component: () => import( '../components/admin/FaqCat')
            },
            {
                path: 'departments',
                name: 'DepartmentsComponent',
                meta: {requiresAuth: true},
                component: () => import( '../components/management/Departments')
            },
            {
                path: 'tasks/:id?',
                meta: {requiresAuth: true},
                name: 'TasksComponent',
                component: () => import('../components/management/TasksComponent')
            },
            {
                path: 'new-request/:id?',
                meta: {requiresAuth: true},
                name: 'NewRequestView',
                component: () => import('../views/management/NewRequestView')
            },
            {
                path: 'edit-request',
                meta: {requiresAuth: true},
                name: 'EditRequestView',
                component: () => import('../views/management/EditRequestView')
            },
            {
                path: 'shifts',
                meta: {requiresAuth: true},
                name: 'ShiftManagement',
                component: () => import('../components/management/ShiftManagement')
            },
            {
                path: 'shifts/assignment',
                meta: {requiresAuth: true},
                name: 'ShiftAssignment',
                component: () => import('../components/management/ShiftAssignment')
            },
            {
                path: 'shifts/live-monitoring',
                meta: {requiresAuth: true},
                name: 'LiveMonitoring',
                component: () => import('../components/management/LiveMonitoring')
            },
            {
                path: 'drafts/qarecords',
                meta: {requiresAuth: true},
                name: 'qa_records',
                component: () => import('../components/management/drafts/qarecords')
            },
            {
                path: 'drafts/portal',
                meta: {requiresAuth: true ,requiredFeatures: ['workflow_management']},
                name: 'portal_c',
                component: () => import('../components/management/drafts/portal')
            },
            {
                path: 'drafts/telegram',
                meta: {requiresAuth: true},
                name: 'telegram_c',
                component: () => import('../components/management/drafts/telegram')
            },
            {
                path: 'drafts/whatsapp',
                meta: {requiresAuth: true},
                name: 'whatsapp_c',
                component: () => import('../components/management/drafts/whatsapp')
            },
            {
                path: 'drafts/instagram',
                meta: {requiresAuth: true},
                name: 'instagram_c',
                component: () => import('../components/management/drafts/instagram')
            },
            {
                path: 'drafts/bale',
                meta: {requiresAuth: true},
                name: 'bale_c',
                component: () => import('../components/management/drafts/bale')
            },
            {
                path: 'drafts/sms',
                name: 'sms_c',
                meta: {requiresAuth: true},

                component: () => import( '../components/management/drafts/sms')
            },
            {
                path: 'filed-management',
                meta: {requiresAuth: true},
                name: 'settingManage',
                component: () => import('../components/management/settingManage')
            },
            {
                path: 'call-notifier',
                meta: {requiresAuth: true},
                name: 'CallNotifier',
                component: () => import('../components/management/CallNotifier')
            },
            {
                path: 'call-notifier-logs/:id?',
                meta: {requiresAuth: true},
                name: 'CallNotifierLogs',
                component: () => import('../components/management/CallNotifierLogs')
            },

            {
                path: 'contact-management',
                meta: {requiresAuth: true},
                name: 'ContactComponent',
                component: () => import('../components/management/ContactComponent'),

            },
            {
                path: 'contact-management/history/:id',
                meta: {requiresAuth: true},
                name: 'ContactHistory',
                component: () => import('../components/management/ContactHistory')
            },


            {
                path: 'reports',
                /*  meta: {requiresAuth: true},*/
                children: [
                    {
                        path: 'all-reports',
                        meta: {requiresAuth: true},
                        name: 'ReportsComponent',
                        component: () => import('../components/management/reports/ReportsComponent')
                    },
                    {
                        path: 'expert-performance',
                        meta: {requiresAuth: true},
                        name: 'ExpertPerformance',
                        component: () => import('../components/management/reports/ExpertPerformance')
                    },
                    {
                        path: 'expert-department',
                        meta: {requiresAuth: true},
                        name: 'ExpertDepartment',
                        component: () => import('../components/management/reports/ExpertDepartment')
                    },
                    {
                        path: 'comparative',
                        meta: {requiresAuth: true},
                        name: 'ComparativeComponent',
                        component: () => import('../components/management/reports/ComparativeComponent')
                    },
                    {
                        path: 'sla',
                        meta: {requiresAuth: true},
                        name: 'SlaComponent',
                        component: () => import('../components/management/reports/SlaComponent')
                    },
                    {
                        path: 'poll-report',
                        meta: {requiresAuth: true},
                        name: 'PollReport',
                        component: () => import('../components/management/reports/PollReport')
                    },
                    {
                        path: 'passenger-analysis',
                        name: 'PassengerAnalysis',
                        meta: {requiresAuth: true},

                        component: () => import( '../components/management/reports/PassengerAnalysis')
                    },
                    {
                        path: 'customer-analysis',
                        name: 'CustomerAnalysis',
                        meta: {requiresAuth: true},

                        component: () => import( '../components/management/reports/CustomerAnalysis')
                    },
                    {
                        path: 'call-monitor',
                        meta: {requiresAuth: true},
                        name: 'CallMonitor',
                        component: () => import('../components/management/callMonitoring/CallMonitor')
                    },

                ]

            },

        ]
    },
    {
        path: '/auth',
        meta: {requiresAuth: false},
        children: [
            {
                path: 'login',
                name: 'LoginComponent',
                component: Login,
            },
            {
                path: 'password',
                name: 'PasswordComponent',
                component: Password,
            }, {
                path: 'otp',
                component: Otp,
            }, {
                path: 'forget-password',
                component: forget,
            }, {
                path: 'choice-password',
                component: NewPassword,
            }, {
                path: 'check-login',
                name: 'CheckLogin',
                component: CheckLogin,
                meta: {requiresAuth: false},
            },

        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    }
]
let accessMenus = {
    portal: false,
    workflow_management: false,
    artificial_intelligence: false,
}
let features = []
if (localStorage.getItem('userInfo') !== null) {
    let data = JSON.parse(localStorage.getItem('userInfo'))
    features = data?.data?.features

}
const updateSettings = () => {
    Object.keys(accessMenus).forEach((key) => {
        const featureName = key.replace(/^is/, '').toLowerCase();
        accessMenus[key] = features?.some((feature) => feature.name && feature.name.toLowerCase() === featureName);
    });
};
updateSettings();
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})
import Cookies from "js-cookie";
import store from "@/store";

router.beforeEach((to, from, next) => {
    if(to.fullPath.includes('auth')){
        store.commit('setWithoutLayout', true)
    }else{
        store.commit('setWithoutLayout', false)
    }
    const nearestWithTitle = to.matched.find(record => record.meta && record.meta.title);

    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    } else {
        document.title = 'اجیستنت';
    }
    if(to.fullPath.includes('management')){
        store.commit('setPanelRole', '0')
        localStorage.setItem('panel-role', '0')
    } else if(to.fullPath.includes('admin')){
        store.commit('setPanelRole', '1')
        localStorage.setItem('panel-role', '1')
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (Cookies.get('token') === undefined) {
            next('/auth/login')
        }

        const requiredFeatures = to.meta.requiredFeatures || [];
        const hasAccess =  requiredFeatures.every((feature) => {
            return accessMenus[feature] === true;
        });
        if (!hasAccess) {
            return next('/'); // یا به '/access-denied'
        }
    }
    if (to.matched.some(record => record.meta.requiresAuth) === false) {

        if (Cookies.get('token') !== undefined) {
            next('/')
        }else{
            next()
        }

    }
    next()
})


export default router
